import { LOCALES } from 'i18n/locales';

export const listObservationPageIntl = {
    [LOCALES.ENGLISH]: {
        'listObservationsPage.page.title': 'Observations',
        'listObservationsPage.page.dateModified': 'Date modified',
        'listObservationsPage.edit': 'Edit observation',
        'listObservationsPage.viewPage': 'View observation',
        'listObservationsPage.viewOnMap': 'View observation on map',
        'listObservationsPage.observationsDeleted': 'Observation(s) Deleted',
        'listObservationsPage.type': 'Type',
        'listObservationsPage.items': 'items'
    },
    [LOCALES.WELSH]: {
        'listObservationsPage.page.title': 'Arsylwadau',
        'listObservationsPage.page.dateModified': 'Dyddiad wedi\'i addasu',
        'listObservationsPage.edit': 'Golygu arsylwad',
        'listObservationsPage.viewPage': 'Gweld arsylwad',
        'listObservationsPage.viewOnMap': 'Gweld arsylwad ar y map',
        'listObservationsPage.observationsDeleted': 'Sylwadau(au) wedi\'u dileu',
        'listObservationsPage.type': 'Math',
        'listObservationsPage.items': 'eitemau'
    }
};
